import { $ } from 'src/shared/js/utils/dom';

const videoButton = $('.pageheader-big__button');
const video = $('.pageheader-big__video');

if (video) {
  const playPauseVideo = () => {
    if (video.paused) {
      playVideo();
    } else {
      pauseVideo();
    }
  };

  const playVideo = () => {
    video.play();
    videoButton.classList.remove('pageheader-big__button--paused');
  };

  const pauseVideo = () => {
    video.pause();
    videoButton.classList.add('pageheader-big__button--paused');
  };

  videoButton.addEventListener('click', playPauseVideo);

  // check if user has enabled reduced motion
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  if (prefersReducedMotion.matches) {
    pauseVideo();
  }
}
